import React from "react";

const ChartHorizontal = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-chart-horizontal"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-chart-horizontal"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M22,15H0v-6H22c1.1,0,2,.9,2,2v2c0,1.1-.9,2-2,2Zm-6-9H0V0H16c1.1,0,2,.9,2,2v2c0,1.1-.9,2-2,2Zm-6,18H0v-6H10c1.1,0,2,.9,2,2v2c0,1.1-.9,2-2,2Z" />
    </svg>
  );
};

export default ChartHorizontal;
